import { shouldRemindToExport } from '@iculogbook/shared';
import { useLiveQuery } from 'dexie-react-hooks';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Button, Card } from '../../components/index.ts';
import { db } from '../../db/db.ts';
import { metaRepository } from '../../db/repositories/meta.ts';

/**
 * The 90-day export reminder — hazard H1's nudge.
 *
 * A dismissible card on the Dashboard, never a modal, and never more than once
 * a month after a dismissal. It is asking a trainee to keep their own copy of
 * their own work, which is reasonable once a quarter and nagging any more often
 * than that.
 */

const DISMISSED_KEY = 'backupReminderDismissedAt';

export function BackupReminder() {
  const navigate = useNavigate();
  const [now] = useState(() => new Date());

  const show = useLiveQuery(async () => {
    const lastExport = await metaRepository.getLastExportAt();
    const dismissed = await db.meta.get(DISMISSED_KEY);
    const entryCount = (await db.cases.count()) + (await db.procedures.count());

    return shouldRemindToExport({
      lastExportAt: lastExport === undefined ? null : new Date(lastExport),
      dismissedAt: typeof dismissed?.value === 'string' ? new Date(dismissed.value) : null,
      entryCount,
      now,
    });
  }, [now]);

  if (show !== true) return null;

  return (
    <Card title="Keep a copy of your logbook">
      <p className="text-sm text-text">
        You have not exported your logbook recently. An export is a file you keep — it works if this
        app disappears, and it is the one copy nobody else can lose for you.
      </p>

      {/* Wraps: at a large text size the two do not fit a narrow phone side by side. */}
      <div className="flex flex-wrap gap-2 pt-3">
        <Button variant="secondary" onClick={() => void navigate('/settings')}>
          Export now
        </Button>
        <Button
          variant="ghost"
          onClick={() => void db.meta.put({ key: DISMISSED_KEY, value: new Date().toISOString() })}
        >
          Later
        </Button>
      </div>
    </Card>
  );
}
